
export interface HotelSearchPayload {
  query?: string;
  city?: string;
  country_code?: string;
  check_in_date: string;
  check_out_date: string;
  adults: number;
  radius_km?: number;
  limit?: number;
}

export interface HotelAddress {
  id?: number;
  name: string;
  latitude?: number;
  longitude?: number;
}

export interface HotelItem {
  external_id: string;
  discover_payload: string;
  name: string;
  address?: HotelAddress;
  rating?: number;
  user_ratings_total?: number;
  link?: string;
  description?: string;
  phone?: string;
  price?: string;
  provider?: string;
  country_code?: string;
}

export interface HotelSearchResult {
  count: number;
  next: string | null;
  previous: string | null;
  results: HotelItem[];
}

export type HotelSortOption = 'best_rating' | 'price_low' | 'price_high';
export type HotelBoardType = 'room_only' | 'breakfast' | 'diner_breakfast' | 'full_board' | 'all_inclusive';

export interface HotelFilters {
  ratings: number[];
  boards: HotelBoardType[];
  sortBy: HotelSortOption;
}

export const HOTEL_FILTERS_INITIAL_VALUES: HotelFilters = {
  ratings: [],
  boards: [],
  sortBy: 'best_rating',
};

export const HOTEL_RATING_OPTIONS: { value: number; label: string }[] = [
  { value: 5, label: '5 star' },
  { value: 4, label: '4 star' },
  { value: 3, label: '3 star' },
  { value: 2, label: '2 star' },
  { value: 1, label: '1 star' },
];

export const HOTEL_BOARD_OPTIONS: { value: HotelBoardType; label: string }[] = [
  { value: 'room_only', label: 'Room only' },
  { value: 'breakfast', label: 'Breakfast included' },
  { value: 'diner_breakfast', label: 'Diner & breakfast' },
  { value: 'full_board', label: 'Full board' },
  { value: 'all_inclusive', label: 'All inclusive' },
];

export const HOTEL_SORT_OPTIONS: { value: HotelSortOption; label: string }[] = [
  { value: 'best_rating', label: 'Best Rating' },
  { value: 'price_low', label: 'Price: Low to High' },
  { value: 'price_high', label: 'Price: High to Low' },
];

export interface HotelSearchContextForSave {
  query: string;
  checkInDate: string;
  checkOutDate: string;
  guests: number;
}
